function setUserToDelete({ input, state }) {
  state.set('client.delete.user', input)
}

export default setUserToDelete



// WEBPACK FOOTER //
// ./src/modules/user/actions/setUserToDelete.js